var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventoryactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2511",
    "data-name": "Rectangle 2511",
    width: 24,
    height: 24,
    transform: "translate(199 339)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4760",
    "data-name": "Mask Group 4760",
    transform: "translate(-199 -339)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Export_1_",
    transform: "translate(183.053 323.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8225",
    "data-name": "Path 8225",
    d: "M151.754,22.776l.476.476-6.11,6.11a1.347,1.347,0,0,0,1.905,1.905l6.11-6.11.476.476a1.35,1.35,0,0,0,2.286-.762l.476-3.334a1.347,1.347,0,0,0-1.524-1.524l-3.334.476A1.35,1.35,0,0,0,151.754,22.776Z",
    transform: "translate(-121.492 0)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8226",
    "data-name": "Path 8226",
    d: "M27.607,20.012H22.694A2.694,2.694,0,0,0,20,22.706V33.213a2.694,2.694,0,0,0,2.694,2.694H33.2A2.694,2.694,0,0,0,35.9,33.213V28.3",
    transform: "translate(0 -0.012)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryactive);
export default __webpack_public_path__ + "static/media/inventoryactive.ed6f4eb8bc0a081103c6e91c208eec36.svg";
export { ForwardRef as ReactComponent };